import actionCreatorFactory from "typescript-fsa";
import { reducerWithInitialState } from "typescript-fsa-reducers";
import { Employee } from "../types/types";
import { RootState } from "./index.store";

/* Selectors */
/**
 * 全ての従業員を返す
 * @param state
 */
export const employeesSelector = (state: RootState) => state.domain.employees;

/* Actions */
const actionCreator = actionCreatorFactory("employees");
export const employeesActions = {
  /* SYSTEM ACTIONS */
  SYSTEM_FETCH_ALL_EMPLOYEES: actionCreator("SYSTEM_FETCH_ALL_EMPLOYEES"),
  /* USER ACTIONS */
  /* REDUCER ACTIONS */
  REDUCER_SET_EMPLOYEES: actionCreator<Employee[]>("REDUCER_SET_EMPLOYEES")
};

/**
 * 従業員リデューサー
 */
export const employeesReducer = reducerWithInitialState<Employee[]>([]).case(
  employeesActions.REDUCER_SET_EMPLOYEES,
  (state, payload) => payload
);
